import { type DevicePlatform } from './types';

declare global {
    interface Window {
        __DEVICE_PLATFORM__?: DevicePlatform;
        __PLATFORM__?: DevicePlatform;
    }
}

export const getDevicePlatform = (): DevicePlatform => window?.__DEVICE_PLATFORM__ ?? 'desktop';

export const getEffectivePlatform = (): DevicePlatform => window?.__PLATFORM__ ?? 'desktop';

//  До гидрации: platform-code читает globalThis.PLATFORM, как на SSR в renderHtmlMiddleware
export const initClientPlatform = (): DevicePlatform => {
    const platform = getEffectivePlatform();

    globalThis.PLATFORM = platform;

    return platform;
};
